<template>
  <v-container>
    <Card
      :title="$t('cart.commentSection')"
      flatToolBar
      colorToolBar="#26384b"
    >
      <template #content>
        <QuillEditorWithoutFiles
          v-model="dataComment"
          v-bind="$props"
          :placeholder="placeholder"
        />
      </template>
      <template v-slot:actions>
        <v-btn
          color="secondary"
          class="mb-2"
          @click="updateGraphicComment"
        >
          {{ $t('forms.btn.save') }}
        </v-btn>
      </template>
    </Card>
  </v-container>
</template>

<script>
import Card from '@/components/card/Card.vue';
import QuillEditorWithoutFiles from '@/components/shared/widgets/forms/comment/QuillEditorWithoutFiles';

export default {
    name: 'GraphicComment',
    components: {
        Card,
        QuillEditorWithoutFiles,
    },
    props: {
        graphicId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            dataComment: '',
            editorOption: {
                modules: {
                    toolbar: {},
                },
            },
        };
    },
    computed: {
        comments() {
            const { comments } = this.$store.getters.getGraphic(this.graphicId);
            return comments;
        },
        placeholder() {
            return this.$t('forms.labels.placeholderComment');
        },
    },
    created() {
        this.setComment();
    },
    methods: {
        setComment() {
            this.dataComment = this.comments;
        },
        updateGraphicComment() {
            const { siteId } = this.$route.params;
            const graphic = { comment: this.dataComment };
            try {
                this.$store.dispatch('editGraphic', { siteId, graphicId: this.graphicId, graphic });
                this.$toasted.global.toast_success({
                    message: this.$t('graphics.commentUpdatedGraphic'),
                });
            } catch (err) {
                return err;
            }
            return null;
        },
    },
};
</script>
